import React, { useState } from "react";

export default function MoreDrillsCard({
  publicTopics = [],
  downloadedTopics = [],
  handleDownloadTopic,
  handleDownloadWithShareCode
}) {
  const [shareCodeInput, setShareCodeInput] = useState("");
  const [downloadMessage, setDownloadMessage] = useState("");

  const handleShareCodeSubmit = async () => {
    const message = await handleDownloadWithShareCode(shareCodeInput);
    setDownloadMessage(message);
    setShareCodeInput("");
  };

  return (
    <div
      style={{
        position: "absolute", // Align with StatsCard
        left: "50%",
        transform: "translateX(-50%)",
        marginTop: 10, // Add 10px space below StatsCard
        width: 400, // Fixed width to match StatsCard
        height: "auto", // Allow height to adjust dynamically
        padding: 37.8, // Match inner spacing of StatsCard
        background: "#141414", // Darker grey background
        borderRadius: 49,
        boxSizing: "border-box",
        color: "#fff",
        fontFamily: "'Inter', 'InterVariable', Arial, sans-serif",
        overflow: "hidden" // Removed boxShadow property
      }}
    >
      {/* More Drills Title */}
      <h2
        style={{
          fontSize: 22,
          fontWeight: 600,
          marginBottom: 16,
          textAlign: "left",
          fontFamily: "Inter",
          fontStyle: "normal",
          color: "#FFFFFF"
        }}
      >
        More Drills
      </h2>

      {/* User Quizzes Section */}
      <div style={{ marginBottom: 20 }}>
        <h3
          style={{
            fontSize: 14,
            fontWeight: 500,
            marginBottom: 12,
            marginTop: 10,
            textAlign: "left",
            color: "#FFFFFF"
          }}
        >
          User Quizzes
        </h3>
        <div style={{ display: "flex", gap: 10 }}>
          <input
            type="text"
            value={shareCodeInput}
            onChange={(e) => setShareCodeInput(e.target.value)}
            placeholder="Enter Share Code"
            style={{
              flex: 1,
              padding: 8,
              borderRadius: 8,
              border: "1px solid #333",
              background: "#232323",
              color: "#fff",
              fontSize: 14
            }}
          />
          <button
            onClick={handleShareCodeSubmit}
            style={{
              background: "#1E83F6",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "8px 12px",
              cursor: "pointer",
              fontSize: 14
            }}
          >
            Download
          </button>
        </div>
        {downloadMessage && (
          <p
            style={{
              marginTop: 8,
              color: "#3be07a",
              fontSize: 12
            }}
          >
            {downloadMessage}
          </p>
        )}
      </div>

      {/* Official Quizzes Section */}
      <h3
        style={{
          fontSize: 14,
          fontWeight: 500,
          marginBottom: 12,
          marginTop: 20,
          textAlign: "left",
          color: "#FFFFFF"
        }}
      >
        Official Quizzes
      </h3>
      <div style={{ overflowY: "auto", maxHeight: "200px" }}>
        {publicTopics.map((topic, index) => (
          <div
            key={topic.id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#232323",
              padding: "10px 15px",
              borderRadius: 12,
              marginBottom: 10
            }}
          >
            <span style={{ fontSize: 14, fontWeight: 500, color: "#FFFFFF" }}>{topic.name}</span>
            {downloadedTopics.includes(topic.shareCode) ? (
              <span style={{ color: "#bbb", fontSize: 12 }}>Downloaded</span>
            ) : (
              <button
                onClick={() => handleDownloadTopic(topic)}
                style={{
                  background: "#333",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "6px 12px",
                  cursor: "pointer",
                  fontSize: 14
                }}
              >
                Download
              </button>
            )}
          </div>
        ))}
        {publicTopics.length > 0 && (
          <p
            style={{
              textAlign: "center",
              color: "#888",
              fontSize: 12,
              marginTop: 20
            }}
          >
            More coming soon
          </p>
        )}
      </div>
    </div>
  );
}